export default {
  PREFIX_MIN: 1000,
  PREFIX_MAX: 9999,
  PREFIX_MIN_LENGTH: 4,
  PREFIX_MAX_LENGTH: 4,
  PASSWORD_MIN_LENGTH: 8,
  PASSWORD_MAX_LENGTH: 32,
};
